import type {UnwrapRef} from "vue";

interface Violation<D extends object> {
    field: keyof D;
    message: string;
}

export interface ErrorResponse<D extends object> {
    message?: string;
    violations?: Violation<D>[];
}

export const getViolationMessage = <D extends object>(field: keyof D, errorResp: UnwrapRef<ErrorResponse<D>>) => {
    return errorResp?.violations?.find(violation => violatesField(field, violation))?.message;
};

const violatesField = <D extends object>(field: keyof D, violation: UnwrapRef<Violation<D>>) => {
    const fieldParts = String(violation.field || "").split(".");
    return fieldParts.length > 0 && fieldParts[fieldParts.length - 1] === field;
};
